import React from 'react';
import { compose } from 'recompose';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { logoutWorker } from 'ducks/auth/actions';
import { user as userType } from 'api/users/types';
import logo from 'assets/images/im_logo2.png';
import { Button, Trans, withTranslated } from 'components';
import { RouterTypes } from 'GLOBAL_TYPES';

const propTypes = {
  ...RouterTypes,
  history: PropTypes.object.isRequired,
  logout: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  user: userType,
};

class Logout extends React.Component {
  
  componentDidMount() {
    const { user, history, logout } = this.props;
    if(user) {
      logout();
    } else {
      history.replace('/login');
    }
  }

  render() {
    const { t } = this.props;

    return (
      <div className="body login-page-wrapper">
        <div className="image-container">
          <div className="im-logo-container">
            <img src={logo} alt="" />
          </div>
        </div>
        <div className="form-container">
          <div className="form-container-inner">
            <div className="form-heading nomargin">
              <h3>
                <Trans>Wylogowano</Trans>
              </h3>
              <h5>Innovative thinking, global perspective</h5>
            </div>
            <Button to="/login" type="link" label={t('Zaloguj się ponownie')} className="stroke-btn" />
          </div>
        </div>
      </div>
    );
  }
}

const mapState = state => ({
  user: state.auth.user
});

const mapDispatch = {
  logout: logoutWorker
};

Logout.propTypes = propTypes;
const enhance = compose(
  connect(mapState, mapDispatch),
  withTranslated
);

export default enhance(Logout);


// WEBPACK FOOTER //
// ./src/pages/logout/Logout.jsx